import './Legal.css';

export default function CookiePolicy() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <div className="legal-header">
          <span className="legal-tag">Legal</span>
          <h1>Cookie Policy</h1>
          <p className="legal-meta">Electradez LLC · Effective Date: March 14, 2025 · Colorado, USA</p>
        </div>

        <div className="legal-body">
          <section>
            <h2>1. What Are Cookies</h2>
            <p>Cookies are small text files stored on your device when you visit a website. They help websites remember your preferences, keep you logged in, and understand how you use the site.</p>
          </section>

          <section>
            <h2>2. How We Use Cookies</h2>
            <p>Electradez uses cookies and similar technologies for the following purposes:</p>

            <h3>Essential Cookies</h3>
            <p>These are required for the platform to function. They include:</p>
            <ul>
              <li>Authentication tokens to keep you logged in</li>
              <li>Session management</li>
              <li>Security cookies to protect against fraud</li>
            </ul>

            <h3>Functional Cookies</h3>
            <p>These remember your preferences such as:</p>
            <ul>
              <li>Your preferred filters on the browse page</li>
              <li>UI state and layout preferences</li>
            </ul>

            <h3>Analytics Cookies</h3>
            <p>These help us understand how users interact with the platform so we can improve it. They collect aggregated, anonymous data about page views and feature usage.</p>
          </section>

          <section>
            <h2>3. Third-Party Cookies</h2>
            <p>We use the following third-party services that may set their own cookies:</p>
            <ul>
              <li><strong>Supabase</strong> — for authentication and session management</li>
              <li><strong>Vercel</strong> — for hosting and performance analytics</li>
            </ul>
            <p>These third parties have their own privacy and cookie policies which we encourage you to review.</p>
          </section>

          <section>
            <h2>4. Managing Cookies</h2>
            <p>You can control and manage cookies through your browser settings. Most browsers allow you to:</p>
            <ul>
              <li>View what cookies are stored</li>
              <li>Delete cookies individually or all at once</li>
              <li>Block cookies from specific or all websites</li>
            </ul>
            <p>Please note that disabling essential cookies may prevent you from logging in or using core features of the platform.</p>
          </section>

          <section>
            <h2>5. Changes to This Policy</h2>
            <p>We may update this Cookie Policy from time to time. Changes will be posted on this page with an updated effective date.</p>
          </section>

          <section>
            <h2>6. Contact</h2>
            <p>Questions about our use of cookies? Contact us at:<br />
            <strong>Electradez LLC</strong><br />
            Colorado, USA<br />
            <a href="mailto:privacy@electradez.com">privacy@electradez.com</a></p>
          </section>
        </div>
      </div>
    </div>
  );
}
